import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextArea from "components/basic/textArea";
import TextField from "components/basic/textField";
import Typography from "components/basic/typography";
import { ReviseQuoteDraft } from "../../types";

export interface ContentSectionProps {
  draft: ReviseQuoteDraft;
  onChange: (patch: Partial<ReviseQuoteDraft>) => void;
}

/** The wording of the quote document — one list item per line. */
const ContentSection: React.FC<ContentSectionProps> = ({ draft, onChange }) => {
  const theme = useTheme();
  const { t } = useTranslation("leads");

  const field = (
    key: "inclusions" | "assumptions" | "notes",
    label: string,
    placeHolder: string,
  ) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
      }}
    >
      <Typography variant="body2">{label}</Typography>
      <TextArea
        minRows={3}
        maxRows={6}
        value={draft[key]}
        placeHolder={placeHolder}
        ariaLabel={label}
        onChange={(e) => onChange({ [key]: e.target.value })}
      />
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
      }}
    >
      <Typography variant="subtitle2">{t("revise.content")}</Typography>
      <Typography
        variant="body2"
        style={{ color: theme.palette.text.secondary }}
      >
        {t("revise.one_per_line")}
      </Typography>

      {field(
        "inclusions",
        t("revise.inclusions"),
        t("revise.inclusions_placeholder"),
      )}
      {field(
        "assumptions",
        t("revise.assumptions"),
        t("revise.assumptions_placeholder"),
      )}
      {field("notes", t("revise.notes"), t("revise.notes_placeholder"))}

      <TextField
        name="paymentTerms"
        label={t("revise.payment_terms")}
        value={draft.paymentTerms}
        onChange={(e) => onChange({ paymentTerms: e.target.value })}
      />
    </div>
  );
};

export default ContentSection;
